import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { episodes, slides } from "@/lib/content";
import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import HomeSidebar from "./components/HomeSidebar";
import EpisodeCard from "@/components/feature/EpisodeCard";

const entries = [
  {
    key: "synopsis",
    to: "/category/synopsis",
    icon: "ri-book-open-line",
    title: "剧情介绍",
    desc: "逐集梳理关键情节与人物关系走向",
  },
  {
    key: "cast",
    to: "/category/cast",
    icon: "ri-user-star-line",
    title: "主演信息",
    desc: "完整演员阵容与角色设定档案",
  },
  {
    key: "updates",
    to: "/category/updates",
    icon: "ri-calendar-check-line",
    title: "剧集更新",
    desc: "最新更新时间与追剧进度速览",
  },
];

export default function Home() {
  useSeo(
    "出轨同学会电视剧全集高清在线观看及剧情介绍",
    "出轨同学会影视内容站提供电视剧全集在线观看和详细剧情介绍，涵盖主演信息与剧集更新，满足用户对电视剧内容的全面需求。",
    "出轨同学会,出轨同学会电视剧,出轨同学会剧情,电视剧在线观看,影视剧介绍,同学会剧情,电视剧全集",
  );

  const featured = [...episodes].sort((a, b) => b.number - a.number).slice(0, 6);

  return (
    <>
      <HeroCarousel slides={slides} />

      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-14 lg:px-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_340px] lg:gap-10">
          <div className="flex min-w-0 flex-col gap-12">
            <section>
              <div className="flex flex-wrap items-end justify-between gap-3">
                <div>
                  <h2 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">
                    剧集精选
                  </h2>
                  <p className="mt-1.5 font-label text-sm text-foreground-500">
                    最新更新的剧集与关键剧情节点，点击卡片查看完整剧情介绍
                  </p>
                </div>
                <Link
                  to="/category/updates"
                  className="inline-flex items-center gap-1 whitespace-nowrap font-label text-sm text-primary-700 transition-colors hover:text-accent-600"
                >
                  查看全部剧集
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-s-line text-base leading-none"></i>
                  </span>
                </Link>
              </div>
              <div className="mt-6 flex flex-col gap-4">
                {featured.map((episode, index) => (
                  <EpisodeCard key={episode.id} episode={episode} rank={index + 1} />
                ))}
              </div>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">
                主题快捷入口
              </h2>
              <p className="mt-1.5 font-label text-sm text-foreground-500">
                按内容类型快速进入对应专区
              </p>
              <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
                {entries.map((entry) => (
                  <Link
                    key={entry.key}
                    to={entry.to}
                    className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
                  >
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-700 group-hover:text-background-50">
                      <i className={`${entry.icon} text-xl leading-none`}></i>
                    </span>
                    <h3 className="mt-4 font-heading text-base font-semibold text-foreground-900">
                      {entry.title}
                    </h3>
                    <p className="mt-1.5 font-label text-sm leading-relaxed text-foreground-500">
                      {entry.desc}
                    </p>
                  </Link>
                ))}
              </div>
            </section>

            <section className="rounded-lg border border-background-200 bg-secondary-50 p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-medium text-accent-800">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-information-line text-xs leading-none"></i>
                </span>
                关于本站
              </span>
              <h2 className="mt-4 font-heading text-xl font-bold text-foreground-900">
                {siteInfo.brand}影视内容站
              </h2>
              <p className="mt-3 font-label text-sm leading-relaxed text-foreground-600">
                {siteInfo.intro}
              </p>
              <p className="mt-3 font-label text-sm leading-relaxed text-foreground-600">
                {siteInfo.intro2}
              </p>
              <Link
                to="/about"
                className="mt-5 inline-flex items-center gap-1 whitespace-nowrap font-label text-sm font-medium text-primary-700 transition-colors hover:text-accent-600"
              >
                了解站点详情
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-s-line text-base leading-none"></i>
                </span>
              </Link>
            </section>
          </div>

          <HomeSidebar />
        </div>
      </div>
    </>
  );
}